module.exports = __webpack_public_path__ + "img/twitter-source-in-ui.ef7a4c07.png";